import { Spin } from "antd";
import { TOUR_TARGETS } from "components/tour";
import {
  FilterNamesEnum,
  GcDashBoardType,
  NavigationPageEnum
} from "../models";
import MatrixBox from "./matrix-box";

function RiskUpdateComponent({
  dashboardData,
  goToFiltered,
  source = "gc"
}: {
  dashboardData: GcDashBoardType | undefined;

  goToFiltered: (page: NavigationPageEnum, filter: FilterNamesEnum) => void;
  source?: "gc" | "sc";
}) {
  return (
    <div
      className="box-border flex flex-col"
      data-tour={TOUR_TARGETS.RISK_UPDATES}
    >
      <div className="box-header bottom-border !p-6">Risk Updates</div>
      <div className="h-96 grow p-5">
        {dashboardData ? (
          <div className="grid grid-cols-2 w-full h-full gap-x-5">
            <MatrixBox
              page={NavigationPageEnum.SubmittalLog}
              matrix={dashboardData?.submittals.risk_assessment}
              goToFiltered={goToFiltered}
              source={source}
            />
            <MatrixBox
              page={NavigationPageEnum.MaterialLog}
              matrix={dashboardData?.materials.risk_assessment}
              goToFiltered={goToFiltered}
              source={source}
            />
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Spin />
          </div>
        )}
      </div>
    </div>
  );
}

export default RiskUpdateComponent;
